import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UpgradeRequest } from '../../../shared/interfaces/firmware.interfaces';

const basePath = '/equipment/upgrade';

@Injectable({
  providedIn: 'root'
})

export class EquipmentUpgradeService {

  constructor(private http: HttpClient) { }

  // request equipment firmware upgrade
  requestUpgrade(equipmentId: number, upgradeRequest: UpgradeRequest): Observable<any> {
    const body = {
      targetVersion: upgradeRequest.targetVersion,
      apn: upgradeRequest.apn,
      user: upgradeRequest.user,
      password: upgradeRequest.password
    };
    return this.http.post<any>(`${basePath}/${equipmentId}`, body);
  }

  // get pending upgrades for equipment
  getPendingUpgrades(equipmentId: number): Observable<any> {
    return this.http.get<any>(`${basePath}/${equipmentId}`);
  }

  // cancel pending upgrades for equipment
  cancelPendingUpgrades(equipmentId: number): Observable<any> {
    return this.http.delete<any>(`${basePath}/${equipmentId}`);
  }

}
